// package: Olameter.WFMS.WorkOrderExecution.InstallDate.v1
// file: wo_install_date_service.proto

var wo_install_date_service_pb = require("./wo_install_date_service_pb");
var google_protobuf_empty_pb = require("google-protobuf/google/protobuf/empty_pb");
var wo_common_message_pb = require("./wo_common_message_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var WorkOrderInstallDateService = (function () {
  function WorkOrderInstallDateService() {}
  WorkOrderInstallDateService.serviceName = "Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDateService";
  return WorkOrderInstallDateService;
}());

WorkOrderInstallDateService.Healthz = {
  methodName: "Healthz",
  service: WorkOrderInstallDateService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: wo_common_message_pb.HealthzResponse
};

WorkOrderInstallDateService.SetInstallDate = {
  methodName: "SetInstallDate",
  service: WorkOrderInstallDateService,
  requestStream: false,
  responseStream: false,
  requestType: wo_install_date_service_pb.InstallDateRequest,
  responseType: wo_install_date_service_pb.InstallDateResultResponse
};

exports.WorkOrderInstallDateService = WorkOrderInstallDateService;

function WorkOrderInstallDateServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

WorkOrderInstallDateServiceClient.prototype.healthz = function healthz(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WorkOrderInstallDateService.Healthz, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkOrderInstallDateServiceClient.prototype.setInstallDate = function setInstallDate(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WorkOrderInstallDateService.SetInstallDate, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.WorkOrderInstallDateServiceClient = WorkOrderInstallDateServiceClient;

